import { useTranslation } from 'react-i18next';
import { TableCell, TableV2 } from '@anytag/shared-atoms';
import { useAuthData } from '@anytag/auth';
import { PaymentPlanName } from '@anytag/graphql';
import { ColumnDef } from '@tanstack/react-table';
import { cn } from '@anytag/shared-utils';

interface KeyFeaturesTableProps {
  className?: string;
  features: any[];
}

export const FeaturesTable = ({ className, features }: KeyFeaturesTableProps) => {
  const { t } = useTranslation();
  const { auth } = useAuthData();

  const currentPlan = auth.subscriptionPlan;
  const columns: ColumnDef<any>[] = [
    {
      accessorKey: 'keyFeatureTitle',
      header: t<string>('Key Features'),
      cell: ({ row }) => (
        <TableCell.Text value={row.original.keyFeatureTitle} className="text-sm [&_li]:text-tertiary" />
      )
    },
    {
      accessorKey: 'tier1',
      header: t<string>(`Plan.${PaymentPlanName.BEGINNER}`),
      cell: ({ row }) => <div className="text-center">{row.original.tier1}</div>,
      meta: { align: 'center' }
    },
    {
      accessorKey: 'tier2',
      header: t<string>(`Plan.${PaymentPlanName.STANDARD}`),
      cell: ({ row }) => <div className="text-center">{row.original.tier2}</div>,
      meta: { align: 'center' }
    },
    {
      accessorKey: 'tier3',
      header: t<string>(`Plan.${PaymentPlanName.ENTERPRISE}`),
      cell: ({ row }) => <div className="text-center">{row.original.tier3}</div>,
      meta: { align: 'center' }
    }
  ];

  return (
    <div className={cn('rounded-sm', className)}>
      <TableV2
        hasBorder={false}
        data={features}
        columns={columns}
        rowHeight="40px"
        className={cn(
          "[&_[data-slot='table-head']:not(:first-of-type)]:w-52",
          {
            "[&_[data-slot='table-body']_[data-slot='table-cell']:nth-of-type(2)]:bg-[#FBFBFD]!":
              currentPlan === PaymentPlanName.BEGINNER
          },
          {
            "[&_[data-slot='table-body']_[data-slot='table-cell']:nth-of-type(3)]:bg-[#FBFBFD]!":
              currentPlan === PaymentPlanName.STANDARD
          },
          {
            "[&_[data-slot='table-body']_[data-slot='table-cell']:nth-of-type(4)]:bg-[#FBFBFD]!":
              currentPlan === PaymentPlanName.ENTERPRISE
          },
          className
        )}
      />
    </div>
  );
};
